// src/pages/FeeChangeLogPage.js
import React, { useEffect, useState } from 'react';
import {
  Container, Typography, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Alert
} from '@mui/material';
import axios from '../api/axios';

const FeeChangeLogPage = () => {
  const [logs, setLogs] = useState([]);
  const [error, setError] = useState(null);

  const fetchLogs = async () => {
    try {
      const res = await axios.get('/admin/fee-change-logs');
      setLogs(res.data.logs);
    } catch (err) {
      setError('Failed to fetch fee change logs');
    }
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  return (
    <Container>
      <Typography variant="h4" sx={{ my: 3 }}>
        Fee Change Logs
      </Typography>

      {error && <Alert severity="error">{error}</Alert>}

      <TableContainer component={Paper} sx={{ mt: 3 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>#ID</TableCell>
              <TableCell>Old %</TableCell>
              <TableCell>New %</TableCell>
              <TableCell>Changed By</TableCell>
              <TableCell>Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {logs.map(log => (
              <TableRow key={log.id}>
                <TableCell>{log.id}</TableCell>
                <TableCell>{log.old_percentage}%</TableCell>
                <TableCell>{log.new_percentage}%</TableCell>
                <TableCell>{log.changed_by_email || `User #${log.changed_by_user_id}`}</TableCell>
                <TableCell>{new Date(log.changed_at).toLocaleString()}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default FeeChangeLogPage;
